import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import api from '#adapter/api/campaigns';
import type * as v2SearchAdvertIdStatWordsGet from '#adapter/api/campaigns/v2/search/{advertID}/stat-words/get';

import { IWord, TWordsTypes, TTabType } from '#component/keywords/types';
import { mapIWordToFull, mapIWordToSelected, mapStringToIWord } from '#component/keywords/services';

interface IState {
    words: TWordsTypes & { fixed: boolean }
}

const initialState: IState = {
    words: {
        excluded: [],
        keywords: [],
        phrase  : [],
        pluse   : [],
        strong  : [],
        fixed   : false
    }
};

function mapIResponseToIState({ words }: v2SearchAdvertIdStatWordsGet.TResponse): TWordsTypes & { fixed: boolean } {
    return {
        fixed   : Boolean(words?.fixed),
        excluded: words?.excluded?.map(mapStringToIWord) ?? [],
        keywords: (words?.keywords?.map((word) => mapIWordToFull(word as IWord)) ?? []),
        phrase  : words?.phrase?.map(mapStringToIWord) ?? [],
        pluse   : words?.pluse?.map(mapStringToIWord) ?? [],
        strong  : words?.strong?.map(mapStringToIWord) ?? []

    };
}

export const searchWordTabs = createSlice({
    initialState,
    name    : 'search-keywords',
    reducers: {
        reset      : () => initialState,
        updateFixed: (state, action: PayloadAction<boolean>) => {
            // eslint-disable-next-line no-param-reassign
            state.words.fixed = action.payload;
        },
        changeSelection: (state, {
            payload: {
                word,
                activeTabKey
            }
        }: PayloadAction<{ word: IWord, activeTabKey: TTabType }>) => {
            // eslint-disable-next-line no-param-reassign
            state.words[activeTabKey] = state.words[activeTabKey]
                .map((el) => (el.keyword === word.keyword ? { ...el, selected: !el.selected } : el));
        },
        selectAll: (state, {
            payload: {
                activeTabKey
            }
        }: PayloadAction<{ activeTabKey: TTabType }>) => ({
            ...state,
            words: {
                ...state.words,
                [activeTabKey]: state.words[activeTabKey].map(mapIWordToSelected)
            }
        }),
        deselectAll: (state, {
            payload: {
                activeTabKey
            }
        }: PayloadAction<{ activeTabKey: TTabType }>) => ({
            ...state,
            words: {
                ...state.words,
                [activeTabKey]: state.words[activeTabKey].map(mapIWordToFull)
            }
        })
    },
    extraReducers: (builder) => {
        builder.addMatcher(api.endpoints.v2SearchAdvertIdStatWordsGet.matchFulfilled, (state, { payload }) => (
            {
                words: {
                    ...mapIResponseToIState(payload)
                }
            }
        ));
    }
});

export default searchWordTabs.reducer;
